import { FC } from 'react';
import { FormItem, ISelectMiniOption, SelectMini, theme } from '@salecycle/ui-component-library';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useReportableDataDispatch, useReportableDataState } from '../../context/UseReportableDataContext';
import { DashboardCurrency } from '../../entities';
import { BarItemElement, BarSectionElement, defaultBarMixin } from '../styles';
import { setCurrencyFilterAction } from 'sections/reportable-data-dashboard/actions/filterActions';
import { getCurrencyOptions } from 'sections/reportable-data-dashboard/utils/mapping';

const FilterTopBarElement = styled.div`
  ${defaultBarMixin};
  border: 1px solid ${theme.vars.newColor.lightGS1};
  position: relative;
`;

export const FilterTopBar: FC = () => {
  const { t } = useTranslation('dashboard');

  const {
    currencies,
    queryParameters: { filterCurrency },
  } = useReportableDataState();
  const dispatch = useReportableDataDispatch();

  const currencyOptions = getCurrencyOptions(currencies, t('filter.currency.dropdown.all'));
  const currencyValue = currencyOptions.find(currencyOption => currencyOption.value === filterCurrency);

  const handleCurrencyChange = (option: ISelectMiniOption) => {
    if (filterCurrency !== option.value) {
      setCurrencyFilterAction(dispatch, option.value as DashboardCurrency);
    }
  };

  return (
    <FilterTopBarElement data-testid="FilterTopBar">
      <BarSectionElement>
        <BarItemElement>
          <FormItem
            tooltipHeading={t('filter.currency.tooltipHeading')}
            tooltipDescription={t('filter.currency.tooltipDescription')}
            isMini={true}
            spacingBelow={false}
            label={`${t('filter.currency.label')}:`}
          >
            <SelectMini
              ariaLabel={t('filter.currency.label')}
              value={currencyValue}
              options={currencyOptions}
              disabled={currencyOptions.length === 0}
              searchable={true}
              onChange={handleCurrencyChange}
            />
          </FormItem>
        </BarItemElement>
      </BarSectionElement>
    </FilterTopBarElement>
  );
};
